import { PersonFilled } from "@assets";
import { ErrorComponent } from "@components/ErrorComponent";
import { ListItem } from "@components/ListItem";
import { Loader } from "@components/Loader";
import { MainLayout, MainLayoutProps } from "@components/MainLayout";
import { Spacing, SpacingSizes } from "@components/Spacing";
import { Body } from "@components/Typography";
import { BeneficiaryType } from "@ctypes";
import { useContributionFlow, useUser } from "@hooks";
import { i18n, Translations } from "@i18n";
import { useNavigate } from "react-router-dom";
import { useStyles } from "./styles";

export const ContributionIndividualRoute = () => {
  const styles = useStyles();
  const navigate = useNavigate();

  const { resetContributionProps } = useContributionFlow();

  const { beneficiaries, loading, error } = useUser();

  const props: MainLayoutProps = {
    pageHeader: i18n.t(Translations.ContributionIndividualRouteHeader),
  };

  if (loading) return <Loader />;
  if (error) return <ErrorComponent />;

  return (
    <MainLayout {...props}>
      <Body style={styles.text}>{i18n.t(Translations.ContributionIndividualRouteTitle)}</Body>
      <Spacing size={SpacingSizes.M} />

      {beneficiaries?.map((beneficiary) => {
        if (!beneficiary?.firstName || !beneficiary?.id) return null;

        const firstName =
          beneficiary.type === BeneficiaryType.Self
            ? i18n.t(Translations.OneTimeContributionRouteYouLabel)
            : beneficiary.firstName;

        const onClick = () => {
          resetContributionProps({ beneficiaryId: beneficiary.id! });
          navigate(-1);
        };

        return (
          <>
            <ListItem leftIcon={<PersonFilled />} title={firstName} onClick={onClick} />
            <Spacing size={SpacingSizes.S} />
          </>
        );
      })}
    </MainLayout>
  );
};
